import dayjs from '~/timeInit';

import { Campaign, CampaignSchedule } from '~/services/AccommodationService';

export const ALL_CAMPAIGN_STATUSES: Array<Campaign['status']> = ['draft', 'active'];

export const campaignStatusPillProps = (
  status: Campaign['status'],
): { label: string; color: 'success' | 'default' } => ({
  label: status,
  color: status === 'active' ? 'success' : 'default',
});

const CAMPAIGN_DATE_FORMAT = 'DD/MM/YYYY';

export function formatCampaignSchedule(schedules: Array<CampaignSchedule>): string {
  if (!schedules.length) {
    return 'Always on';
  }
  if (schedules.length > 1) {
    return `${schedules.length} schedules`;
  }
  const [{ activeStartDate, activeEndDate }] = schedules;
  return `${dayjs(activeStartDate).format(CAMPAIGN_DATE_FORMAT)} – ${dayjs(activeEndDate).format(CAMPAIGN_DATE_FORMAT)}`;
}
